import { usePermission } from './usePermission';

export const useCanEditEntityGroups = () => {
  return usePermission({
    permission: { resourceId: 'entity_groups', resourceType: 'edit' },
  });
};
